export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	bulbasaur: {
		randomBattleMoves: ["bodyslam", "sleeppowder"],
		essentialMove: "razorleaf",
		exclusiveMoves: ["megadrain", "swordsdance", "swordsdance"],
		tier: "LC",
	},
	ivysaur: {
		randomBattleMoves: ["bodyslam", "sleeppowder", "swordsdance"],
		essentialMove: "razorleaf",
		tier: "NFE",
	},
	venusaur: {
		randomBattleMoves: ["bodyslam", "hyperbeam", "sleeppowder", "swordsdance"],
		essentialMove: "razorleaf",
		tier: "UU",
	},
	charmander: {
		randomBattleMoves: ["bodyslam", "slash"],
		essentialMove: "fireblast",
		exclusiveMoves: ["counter", "seismictoss"],
		comboMoves: ["bodyslam", "fireblast", "submission", "swordsdance"],
		tier: "LC",
	},
	charmeleon: {
		randomBattleMoves: ["bodyslam", "slash"],
		essentialMove: "fireblast",
		exclusiveMoves: ["counter", "swordsdance"],
		comboMoves: ["bodyslam", "fireblast", "submission", "swordsdance"],
		tier: "NFE",
	},
	charizard: {
		randomBattleMoves: ["bodyslam", "earthquake", "slash"],
		essentialMove: "fireblast",
		comboMoves: ["hyperbeam", "swordsdance"],
		tier: "NU",
	},
	squirtle: {
		randomBattleMoves: ["blizzard", "hydropump", "seismictoss", "surf"],
		exclusiveMoves: ["bodyslam", "counter"],
		tier: "LC",
	},
	wartortle: {
		randomBattleMoves: ["blizzard", "bodyslam", "hydropump", "surf"],
		exclusiveMoves: ["counter", "rest", "seismictoss"],
		tier: "NFE",
	},
	blastoise: {
		randomBattleMoves: ["blizzard", "bodyslam", "hydropump", "surf"],
		exclusiveMoves: ["earthquake", "rest"],
		tier: "NU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		randomBattleMoves: ["psychic", "sleeppowder", "stunspore"],
		exclusiveMoves: ["megadrain", "psywave"],
		tier: "PU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		randomBattleMoves: ["megadrain", "swordsdance", "twineedle"],
		exclusiveMoves: ["doubleedge", "doubleedge", "hyperbeam"],
		comboMoves: ["agility", "hyperbeam", "swordsdance", "twineedle"],
		tier: "PU",
	},
	pidgey: {
		randomBattleMoves: ["agility", "doubleedge", "skyattack"],
		exclusiveMoves: ["mimic", "mirrormove", "reflect", "sandattack", "substitute", "quickattack", "toxic"],
		tier: "LC",
	},
	pidgeotto: {
		randomBattleMoves: ["agility", "doubleedge", "skyattack"],
		exclusiveMoves: ["mimic", "mirrormove", "reflect", "sandattack", "substitute", "quickattack", "toxic"],
		tier: "NFE",
	},
	pidgeot: {
		randomBattleMoves: ["agility", "doubleedge", "hyperbeam"],
		exclusiveMoves: ["mimic", "mirrormove", "reflect", "sandattack", "skyattack", "skyattack", "substitute", "quickattack", "toxic"],
		tier: "PU",
	},
	rattata: {
		randomBattleMoves: ["blizzard", "bodyslam"],
		// The two Thunderbolts are not a mistake, but specifically requested
		exclusiveMoves: ["thunderbolt", "thunderbolt", "quickattack"],
		essentialMove: "superfang",
		tier: "LC",
	},
	raticate: {
		randomBattleMoves: ["blizzard", "bodyslam", "hyperbeam"],
		essentialMove: "superfang",
		tier: "NU",
	},
	spearow: {
		randomBattleMoves: ["agility", "doubleedge", "drillpeck"],
		exclusiveMoves: ["leer", "mimic", "mirrormove", "substitute", "toxic"],
		tier: "LC",
	},
	fearow: {
		randomBattleMoves: ["agility", "doubleedge", "drillpeck", "hyperbeam"],
		tier: "PU",
	},
	ekans: {
		randomBattleMoves: ["bodyslam", "earthquake", "glare", "rockslide"],
		tier: "LC",
	},
	arbok: {
		randomBattleMoves: ["earthquake", "glare", "hyperbeam"],
		exclusiveMoves: ["bodyslam", "rockslide"],
		tier: "PU",
	},
	pikachu: {
		randomBattleMoves: ["surf", "thunderwave"],
		essentialMove: "thunderbolt",
		exclusiveMoves: ["agility", "bodyslam", "seismictoss", "thunder"],
		tier: "LC",
	},
	raichu: {
		randomBattleMoves: ["surf", "thunderwave"],
		essentialMove: "thunderbolt",
		exclusiveMoves: ["agility", "bodyslam", "hyperbeam", "seismictoss", "thunder"],
		tier: "NUBL",
	},
	sandshrew: {
		randomBattleMoves: ["bodyslam", "rockslide", "swordsdance"],
		essentialMove: "earthquake",
		tier: "LC",
	},
	sandslash: {
		randomBattleMoves: ["bodyslam", "rockslide", "swordsdance"],
		essentialMove: "earthquake",
		tier: "PU",
	},
	nidoranf: {
		randomBattleMoves: ["blizzard", "bodyslam", "thunderbolt"],
		exclusiveMoves: ["doubleedge", "doublekick"],
		tier: "LC",
	},
	nidorina: {
		randomBattleMoves: ["blizzard", "bodyslam", "thunderbolt"],
		exclusiveMoves: ["bubblebeam", "doubleedge", "doublekick"],
		tier: "NFE",
	},
	nidoqueen: {
		randomBattleMoves: ["blizzard", "bodyslam", "thunderbolt"],
		essentialMove: "earthquake",
		tier: "PU",
	},
	nidoranm: {
		randomBattleMoves: ["blizzard", "bodyslam", "thunderbolt"],
		exclusiveMoves: ["doubleedge", "doublekick"],
		tier: "LC",
	},
	nidorino: {
		randomBattleMoves: ["blizzard", "bodyslam", "thunderbolt"],
		exclusiveMoves: ["bubblebeam", "doubleedge", "doublekick"],
		tier: "NFE",
	},
	nidoking: {
		randomBattleMoves: ["blizzard", "bodyslam"],
		essentialMove: "earthquake",
		exclusiveMoves: ["rockslide", "thunder", "thunderbolt"],
		tier: "NU",
	},
	clefairy: {
		randomBattleMoves: ["bodyslam", "thunderbolt", "thunderwave"],
		essentialMove: "blizzard",
		exclusiveMoves: ["counter", "psychic", "seismictoss", "sing", "sing"],
		tier: "LC",
	},
	clefable: {
		randomBattleMoves: ["bodyslam", "thunderbolt", "thunderwave"],
		essentialMove: "blizzard",
		exclusiveMoves: ["counter", "hyperbeam", "psychic", "sing", "sing"],
		tier: "NU",
	},
	vulpix: {
		randomBattleMoves: ["bodyslam", "confuseray", "fireblast"],
		exclusiveMoves: ["flamethrower", "reflect", "substitute"],
		tier: "LC",
	},
	ninetales: {
		randomBattleMoves: ["bodyslam", "confuseray", "fireblast"],
		exclusiveMoves: ["flamethrower", "hyperbeam", "reflect", "substitute"],
		tier: "NU",
	},
	jigglypuff: {
		randomBattleMoves: ["blizzard", "bodyslam", "seismictoss", "thunderwave"],
		exclusiveMoves: ["counter", "sing"],
		tier: "LC",
	},
	wigglytuff: {
		randomBattleMoves: ["blizzard", "bodyslam", "thunderwave"],
		exclusiveMoves: ["counter", "hyperbeam", "sing"],
		tier: "NU",
	},
	zubat: {
		randomBattleMoves: ["confuseray", "doubleedge", "megadrain", "toxic"],
		tier: "LC",
	},
	golbat: {
		randomBattleMoves: ["confuseray", "doubleedge", "hyperbeam", "megadrain"],
		tier: "PU",
	},
	oddish: {
		randomBattleMoves: ["doubleedge", "sleeppowder"],
		essentialMove: "megadrain",
		exclusiveMoves: ["stunspore", "stunspore", "swordsdance"],
		tier: "LC",
	},
	gloom: {
		randomBattleMoves: ["doubleedge", "sleeppowder"],
		essentialMove: "megadrain",
		exclusiveMoves: ["stunspore", "stunspore", "swordsdance"],
		tier: "NFE",
	},
	vileplume: {
		randomBattleMoves: ["bodyslam", "sleeppowder", "stunspore", "swordsdance"],
		essentialMove: "megadrain",
		tier: "PU",
	},
	paras: {
		randomBattleMoves: ["bodyslam", "megadrain"],
		essentialMove: "spore",
		exclusiveMoves: ["growth", "slash", "stunspore", "stunspore", "swordsdance"],
		tier: "LC",
	},
	parasect: {
		randomBattleMoves: ["bodyslam", "megadrain"],
		essentialMove: "spore",
		exclusiveMoves: ["growth", "hyperbeam", "slash", "stunspore", "stunspore", "swordsdance"],
		tier: "PU",
	},
	venonat: {
		randomBattleMoves: ["psychic", "sleeppowder", "stunspore"],
		exclusiveMoves: ["doubleedge", "megadrain", "psywave"],
		tier: "LC",
	},
	venomoth: {
		randomBattleMoves: ["psychic", "sleeppowder", "stunspore"],
		exclusiveMoves: ["doubleedge", "megadrain", "megadrain"],
		tier: "NU",
	},
	diglett: {
		randomBattleMoves: ["bodyslam", "rockslide", "slash"],
		essentialMove: "earthquake",
		tier: "LC",
	},
	dugtrio: {
		randomBattleMoves: ["bodyslam", "rockslide", "slash"],
		essentialMove: "earthquake",
		tier: "UU",
	},
	meowth: {
		randomBattleMoves: ["bodyslam", "bubblebeam"],
		essentialMove: "slash",
		exclusiveMoves: ["thunder", "thunderbolt"],
		tier: "LC",
	},
	persian: {
		randomBattleMoves: ["bodyslam", "bubblebeam"],
		essentialMove: "slash",
		exclusiveMoves: ["hyperbeam", "hyperbeam", "thunder", "thunderbolt"],
		tier: "UU",
	},
	psyduck: {
		randomBattleMoves: ["amnesia", "blizzard"],
		essentialMove: "surf",
		exclusiveMoves: ["bodyslam", "hydropump", "rest", "seismictoss"],
		tier: "LC",
	},
	golduck: {
		randomBattleMoves: ["amnesia", "blizzard"],
		essentialMove: "surf",
		exclusiveMoves: ["bodyslam", "hydropump", "rest", "seismictoss"],
		tier: "NUBL",
	},
	mankey: {
		randomBattleMoves: ["bodyslam", "rockslide", "submission"],
		exclusiveMoves: ["counter", "megakick"],
		tier: "LC",
	},
	primeape: {
		randomBattleMoves: ["bodyslam", "rockslide", "submission"],
		exclusiveMoves: ["counter", "hyperbeam", "hyperbeam"],
		tier: "PU",
	},
	growlithe: {
		randomBattleMoves: ["bodyslam", "fireblast", "flamethrower", "reflect"],
		tier: "LC",
	},
	arcanine: {
		randomBattleMoves: ["bodyslam", "fireblast", "hyperbeam"],
		exclusiveMoves: ["flamethrower", "reflect"],
		tier: "PU",
	},
	poliwag: {
		randomBattleMoves: ["blizzard", "surf"],
		essentialMove: "amnesia",
		exclusiveMoves: ["hypnosis", "hypnosis", "psychic"],
		tier: "LC",
	},
	poliwhirl: {
		randomBattleMoves: ["blizzard", "surf"],
		essentialMove: "amnesia",
		exclusiveMoves: ["counter", "hypnosis", "hypnosis", "psychic"],
		tier: "NU",
	},
	poliwrath: {
		randomBattleMoves: ["blizzard", "bodyslam", "earthquake", "submission"],
		essentialMove: "surf",
		exclusiveMoves: ["hypnosis", "hypnosis", "psychic"],
		comboMoves: ["amnesia", "blizzard"],
		tier: "NUBL",
	},
	abra: {
		randomBattleMoves: ["psychic", "seismictoss", "thunderwave"],
		exclusiveMoves: ["counter", "reflect"],
		tier: "LC",
	},
	kadabra: {
		randomBattleMoves: ["psychic", "recover", "thunderwave"],
		exclusiveMoves: ["counter", "reflect", "reflect", "seismictoss", "seismictoss"],
		tier: "UU",
	},
	alakazam: {
		randomBattleMoves: ["psychic", "recover", "thunderwave"],
		exclusiveMoves: ["counter", "reflect", "reflect", "seismictoss", "seismictoss"],
		tier: "OU",
	},
	machop: {
		randomBattleMoves: ["bodyslam", "earthquake", "submission"],
		exclusiveMoves: ["counter", "rockslide", "rockslide"],
		tier: "LC",
	},
	machoke: {
		randomBattleMoves: ["bodyslam", "earthquake", "submission"],
		exclusiveMoves: ["counter", "rockslide", "rockslide"],
		tier: "NFE",
	},
	machamp: {
		randomBattleMoves: ["bodyslam", "earthquake", "submission"],
		exclusiveMoves: ["counter", "hyperbeam", "rockslide", "rockslide"],
		tier: "PU",
	},
	bellsprout: {
		randomBattleMoves: ["doubleedge", "sleeppowder", "stunspore", "swordsdance"],
		essentialMove: "razorleaf",
		tier: "LC",
	},
	weepinbell: {
		randomBattleMoves: ["doubleedge", "sleeppowder", "stunspore", "swordsdance"],
		essentialMove: "razorleaf",
		tier: "NFE",
	},
	victreebel: {
		randomBattleMoves: ["bodyslam", "sleeppowder", "stunspore"],
		essentialMove: "razorleaf",
		comboMoves: ["hyperbeam", "swordsdance"],
		tier: "UU",
	},
	tentacool: {
		randomBattleMoves: ["barrier", "hydropump", "surf"],
		essentialMove: "blizzard",
		exclusiveMoves: ["megadrain", "megadrain"],
		comboMoves: ["hydropump", "surf"],
		tier: "LC",
	},
	tentacruel: {
		randomBattleMoves: ["blizzard", "hydropump", "hyperbeam", "surf"],
		essentialMove: "swordsdance",
		tier: "UU",
	},
	geodude: {
		randomBattleMoves: ["bodyslam", "earthquake", "explosion", "rockslide"],
		tier: "LC",
	},
	graveler: {
		randomBattleMoves: ["bodyslam", "earthquake", "explosion", "rockslide"],
		tier: "NFE",
	},
	golem: {
		randomBattleMoves: ["bodyslam", "earthquake", "explosion", "rockslide"],
		tier: "NU",
	},
	ponyta: {
		randomBattleMoves: ["agility", "bodyslam", "fireblast", "reflect"],
		tier: "LC",
	},
	rapidash: {
		randomBattleMoves: ["agility", "bodyslam", "fireblast", "hyperbeam"],
		tier: "PU",
	},
	slowpoke: {
		randomBattleMoves: ["earthquake", "surf"],
		essentialMove: "thunderwave",
		exclusiveMoves: ["blizzard", "psychic", "rest"],
		comboMoves: ["amnesia", "surf"],
		tier: "LC",
	},
	slowbro: {
		randomBattleMoves: ["amnesia", "surf", "thunderwave"],
		exclusiveMoves: ["blizzard", "psychic", "rest", "rest"],
		tier: "OU",
	},
	magnemite: {
		randomBattleMoves: ["thunder", "thunderbolt", "thunderwave"],
		exclusiveMoves: ["doubleedge", "mimic", "substitute", "toxic"],
		tier: "LC",
	},
	magneton: {
		randomBattleMoves: ["thunder", "thunderbolt", "thunderwave"],
		exclusiveMoves: ["doubleedge", "hyperbeam", "hyperbeam", "mimic", "substitute", "toxic"],
		tier: "PU",
	},
	farfetchd: {
		randomBattleMoves: ["agility", "bodyslam", "swordsdance"],
		essentialMove: "slash",
		tier: "PU",
	},
	doduo: {
		randomBattleMoves: ["agility", "bodyslam", "doubleedge", "drillpeck"],
		tier: "LC",
	},
	dodrio: {
		randomBattleMoves: ["agility", "bodyslam", "drillpeck", "hyperbeam"],
		tier: "UU",
	},
	seel: {
		randomBattleMoves: ["blizzard", "bodyslam", "surf"],
		exclusiveMoves: ["mimic", "rest"],
		tier: "LC",
	},
	dewgong: {
		randomBattleMoves: ["blizzard", "bodyslam", "surf"],
		exclusiveMoves: ["hyperbeam", "mimic", "rest", "rest"],
		tier: "UU",
	},
	grimer: {
		randomBattleMoves: ["bodyslam", "sludge"],
		essentialMove: "explosion",
		exclusiveMoves: ["fireblast", "megadrain", "megadrain", "screech"],
		tier: "LC",
	},
	muk: {
		randomBattleMoves: ["bodyslam", "sludge"],
		essentialMove: "explosion",
		exclusiveMoves: ["fireblast", "hyperbeam", "megadrain", "megadrain"],
		tier: "PU",
	},
	shellder: {
		randomBattleMoves: ["blizzard", "doubleedge", "explosion", "surf"],
		tier: "LC",
	},
	cloyster: {
		randomBattleMoves: ["blizzard", "explosion", "surf"],
		exclusiveMoves: ["doubleedge", "hyperbeam", "hyperbeam"],
		tier: "OU",
	},
	gastly: {
		randomBattleMoves: ["explosion", "megadrain", "nightshade", "psychic"],
		essentialMove: "thunderbolt",
		exclusiveMoves: ["confuseray", "hypnosis", "hypnosis"],
		tier: "LC",
	},
	haunter: {
		randomBattleMoves: ["explosion", "megadrain", "nightshade", "psychic"],
		essentialMove: "thunderbolt",
		exclusiveMoves: ["confuseray", "hypnosis", "hypnosis"],
		tier: "UU",
	},
	gengar: {
		randomBattleMoves: ["explosion", "megadrain", "nightshade", "psychic"],
		essentialMove: "thunderbolt",
		exclusiveMoves: ["confuseray", "hypnosis", "hypnosis"],
		tier: "OU",
	},
	onix: {
		randomBattleMoves: ["bodyslam", "earthquake", "explosion", "rockslide"],
		tier: "PU",
	},
	drowzee: {
		randomBattleMoves: ["hypnosis", "psychic", "thunderwave"],
		exclusiveMoves: ["counter", "reflect", "rest", "seismictoss", "seismictoss"],
		tier: "LC",
	},
	hypno: {
		randomBattleMoves: ["hypnosis", "psychic", "thunderwave"],
		exclusiveMoves: ["counter", "reflect", "rest", "rest", "seismictoss", "seismictoss"],
		tier: "UU",
	},
	krabby: {
		randomBattleMoves: ["blizzard", "bodyslam", "crabhammer", "swordsdance"],
		tier: "LC",
	},
	kingler: {
		randomBattleMoves: ["bodyslam", "crabhammer", "hyperbeam", "swordsdance"],
		tier: "NU",
	},
	voltorb: {
		randomBattleMoves: ["explosion", "thunderbolt", "thunderwave"],
		exclusiveMoves: ["screech", "thunder", "toxic"],
		tier: "LC",
	},
	electrode: {
		randomBattleMoves: ["explosion", "thunderbolt", "thunderwave"],
		exclusiveMoves: ["hyperbeam", "screech", "thunder", "toxic"],
		tier: "PU",
	},
	exeggcute: {
		randomBattleMoves: ["sleeppowder", "stunspore"],
		essentialMove: "psychic",
		exclusiveMoves: ["doubleedge", "explosion", "explosion"],
		tier: "NU",
	},
	exeggutor: {
		randomBattleMoves: ["explosion", "psychic", "sleeppowder"],
		exclusiveMoves: ["doubleedge", "eggbomb", "hyperbeam", "megadrain", "megadrain", "stunspore", "stunspore", "stunspore"],
		tier: "OU",
	},
	cubone: {
		randomBattleMoves: ["blizzard", "bodyslam", "earthquake", "seismictoss"],
		tier: "LC",
	},
	marowak: {
		randomBattleMoves: ["blizzard", "bodyslam", "earthquake", "seismictoss"],
		tier: "PU",
	},
	hitmonlee: {
		randomBattleMoves: ["bodyslam", "highjumpkick", "seismictoss"],
		exclusiveMoves: ["counter", "counter", "meditate"],
		tier: "PU",
	},
	hitmonchan: {
		randomBattleMoves: ["bodyslam", "seismictoss", "submission"],
		exclusiveMoves: ["agility", "counter", "counter"],
		tier: "PU",
	},
	lickitung: {
		randomBattleMoves: ["hyperbeam", "swordsdance"],
		essentialMove: "bodyslam",
		exclusiveMoves: ["blizzard", "earthquake", "earthquake", "earthquake"],
		tier: "PU",
	},
	koffing: {
		randomBattleMoves: ["explosion", "fireblast", "sludge", "thunderbolt"],
		tier: "LC",
	},
	weezing: {
		randomBattleMoves: ["explosion", "fireblast", "sludge", "thunderbolt"],
		tier: "PU",
	},
	rhyhorn: {
		randomBattleMoves: ["bodyslam", "earthquake", "rockslide", "substitute"],
		tier: "LC",
	},
	rhydon: {
		randomBattleMoves: ["bodyslam", "earthquake", "rockslide"],
		exclusiveMoves: ["hyperbeam", "substitute", "substitute"],
		tier: "OU",
	},
	chansey: {
		randomBattleMoves: ["icebeam", "thunderwave"],
		essentialMove: "softboiled",
		exclusiveMoves: ["counter", "reflect", "seismictoss", "sing", "thunderbolt", "thunderbolt", "thunderbolt"],
		tier: "OU",
	},
	tangela: {
		randomBattleMoves: ["bodyslam", "sleeppowder", "swordsdance"],
		essentialMove: "megadrain",
		comboMoves: ["growth", "stunspore"],
		tier: "UU",
	},
	kangaskhan: {
		randomBattleMoves: ["bodyslam", "earthquake", "hyperbeam"],
		exclusiveMoves: ["counter", "rockslide", "rockslide", "surf"],
		tier: "UU",
	},
	horsea: {
		randomBattleMoves: ["agility", "blizzard"],
		essentialMove: "surf",
		exclusiveMoves: ["doubleedge", "hydropump", "smokescreen"],
		tier: "LC",
	},
	seadra: {
		randomBattleMoves: ["agility", "blizzard"],
		essentialMove: "surf",
		exclusiveMoves: ["doubleedge", "hydropump", "hyperbeam", "smokescreen"],
		tier: "NU",
	},
	goldeen: {
		randomBattleMoves: ["agility", "blizzard", "doubleedge", "surf"],
		tier: "LC",
	},
	seaking: {
		randomBattleMoves: ["blizzard", "doubleedge", "surf"],
		exclusiveMoves: ["agility", "agility", "hyperbeam"],
		tier: "PU",
	},
	staryu: {
		randomBattleMoves: ["blizzard", "thunderbolt", "thunderwave"],
		essentialMove: "recover",
		exclusiveMoves: ["hydropump", "surf", "surf"],
		tier: "LC",
	},
	starmie: {
		randomBattleMoves: ["blizzard", "thunderbolt", "thunderwave"],
		essentialMove: "recover",
		exclusiveMoves: ["hydropump", "psychic", "surf", "surf"],
		tier: "OU",
	},
	mrmime: {
		randomBattleMoves: ["psychic", "seismictoss", "thunderbolt", "thunderwave"],
		tier: "NU",
	},
	scyther: {
		randomBattleMoves: ["agility", "hyperbeam", "slash", "swordsdance"],
		tier: "PU",
	},
	jynx: {
		randomBattleMoves: ["blizzard", "lovelykiss", "psychic"],
		exclusiveMoves: ["bodyslam", "counter", "counter", "mimic", "seismictoss"],
		tier: "OU",
	},
	electabuzz: {
		randomBattleMoves: ["psychic", "seismictoss", "thunderbolt", "thunderwave"],
		tier: "UU",
	},
	magmar: {
		randomBattleMoves: ["bodyslam", "confuseray", "fireblast"],
		exclusiveMoves: ["hyperbeam", "psychic"],
		tier: "PU",
	},
	pinsir: {
		randomBattleMoves: ["bodyslam", "hyperbeam", "swordsdance"],
		exclusiveMoves: ["seismictoss", "submission", "submission"],
		tier: "PU",
	},
	tauros: {
		randomBattleMoves: ["bodyslam", "earthquake", "hyperbeam"],
		exclusiveMoves: ["blizzard", "blizzard", "blizzard", "thunderbolt"],
		tier: "OU",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		randomBattleMoves: ["blizzard", "bodyslam", "hyperbeam", "thunderbolt"],
		exclusiveMoves: ["hydropump", "surf"],
		tier: "UU",
	},
	lapras: {
		randomBattleMoves: ["bodyslam", "confuseray", "rest", "sing", "surf"],
		essentialMove: "blizzard",
		exclusiveMoves: ["thunderbolt", "thunderbolt"],
		tier: "UU",
	},
	ditto: {
		randomBattleMoves: ["transform"],
		tier: "PU",
	},
	eevee: {
		randomBattleMoves: ["doubleedge", "quickattack", "reflect"],
		essentialMove: "bodyslam",
		exclusiveMoves: ["bide", "mimic", "sandattack", "tailwhip"],
		tier: "LC",
	},
	vaporeon: {
		randomBattleMoves: ["blizzard", "rest"],
		essentialMove: "surf",
		exclusiveMoves: ["bodyslam", "hydropump", "mimic"],
		tier: "UU",
	},
	jolteon: {
		randomBattleMoves: ["bodyslam", "thunderbolt", "thunderwave"],
		exclusiveMoves: ["agility", "agility", "doublekick", "pinmissile", "pinmissile"],
		tier: "OU",
	},
	flareon: {
		randomBattleMoves: ["bodyslam", "fireblast", "hyperbeam", "quickattack"],
		tier: "PU",
	},
	porygon: {
		randomBattleMoves: ["blizzard", "thunderwave"],
		essentialMove: "recover",
		exclusiveMoves: ["doubleedge", "psychic", "thunderbolt", "triattack"],
		tier: "NU",
	},
	omanyte: {
		randomBattleMoves: ["bodyslam", "hydropump", "rest", "surf"],
		essentialMove: "blizzard",
		tier: "LC",
	},
	omastar: {
		randomBattleMoves: ["blizzard", "hydropump", "seismictoss", "surf"],
		exclusiveMoves: ["bodyslam", "rest"],
		tier: "UU",
	},
	kabuto: {
		randomBattleMoves: ["blizzard", "bodyslam", "slash", "surf"],
		tier: "LC",
	},
	kabutops: {
		randomBattleMoves: ["hyperbeam", "surf", "swordsdance"],
		exclusiveMoves: ["bodyslam", "slash"],
		tier: "NU",
	},
	aerodactyl: {
		randomBattleMoves: ["doubleedge", "fireblast", "hyperbeam", "skyattack"],
		tier: "UU",
	},
	snorlax: {
		randomBattleMoves: ["bodyslam", "rest", "selfdestruct", "thunderbolt"],
		essentialMove: "amnesia",
		exclusiveMoves: ["blizzard", "blizzard"],
		comboMoves: ["bodyslam", "earthquake", "hyperbeam", "selfdestruct"],
		tier: "OU",
	},
	articuno: {
		randomBattleMoves: ["agility", "hyperbeam", "icebeam", "mimic", "reflect"],
		essentialMove: "blizzard",
		comboMoves: ["icebeam", "reflect", "rest"],
		tier: "UU",
	},
	zapdos: {
		randomBattleMoves: ["agility", "drillpeck", "thunderbolt", "thunderwave"],
		tier: "OU",
	},
	moltres: {
		randomBattleMoves: ["agility", "fireblast", "hyperbeam"],
		exclusiveMoves: ["doubleedge", "reflect", "skyattack"],
		tier: "NU",
	},
	dratini: {
		randomBattleMoves: ["bodyslam", "hyperbeam", "thunderbolt", "thunderwave"],
		essentialMove: "blizzard",
		tier: "LC",
	},
	dragonair: {
		randomBattleMoves: ["bodyslam", "hyperbeam", "thunderbolt", "thunderwave"],
		essentialMove: "blizzard",
		tier: "NFE",
	},
	dragonite: {
		randomBattleMoves: ["bodyslam", "hyperbeam", "thunderbolt", "thunderwave"],
		essentialMove: "blizzard",
		tier: "UU",
	},
	mewtwo: {
		randomBattleMoves: ["blizzard", "recover", "thunderbolt"],
		essentialMove: "amnesia",
		exclusiveMoves: ["psychic", "psychic"],
		comboMoves: ["barrier", "rest"],
		tier: "Uber",
	},
	mew: {
		randomBattleMoves: ["blizzard", "earthquake", "thunderbolt", "thunderwave"],
		essentialMove: "psychic",
		exclusiveMoves: ["explosion", "softboiled", "softboiled"],
		comboMoves: ["earthquake", "hyperbeam", "swordsdance"],
		tier: "Uber",
	},
	missingno: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
};
